/**
 * @file
 * Fulbright news listing.
 *
 * Initializes Masonry for the news listing and lets Masonry know about DOM
 * updates.
 *
 * @author Ville Pesonen | Karhu Helsinki Oy <ville.pesonen@karhuhelsinki.fi>
 */

(function($) {
  var $listing_block = $("#block-news-listing");
  if ($listing_block.length) {
    // It is assumed news listing block uses Views Infinite Scroll.
    var $wrapper = $listing_block.find(
      ".views-infinite-scroll-content-wrapper"
    );

    // Make sure Masonry is initialized after all the images have been loaded.
    // This is done by calling imagesLoaded-library first and initializing
    // Masonry in the callback.
    // First new item should appear different than the other (double-width). It
    // has been added the class 'highlight-item'. That item will be "stamped"
    // with Masonry and disregared from the grid items.
    // All the grid items are given extra class 'processed' in order to be able
    // to inform Masonry about appended grid items later on (Views AJAX-calls).
    $wrapper
      .imagesLoaded(function() {
        $("#block-news-listing")
          .find(".views-infinite-scroll-content-wrapper")
          .masonry({
            horizontalOrder: true,
            itemSelector: ".grid-item",
            percentPosition: true,
            stamp: ".highlight-item",
            gutter: 30
          });
      })
      .find(".grid-item")
      .addClass("processed");

    // Bind listener on ajaxComplete-event in order to inform Masonry about
    // new grid items.
    $(document).on("ajaxComplete", function(event, xhr, settings) {
      // Assume no other AJAX-enabled Views exist on the news listing page and
      // act on AJAX-request using the Views AJAX url. It should be triggered by
      // Views Infinite Scroll ('Display More'-pager link).
      if (settings.url.startsWith("/views/ajax")) {
        // Find grid items not already laid out by Masonry with manually handled
        // class 'processed'.
        var $rows = $wrapper
          .find(".grid-item:not(.processed)")
          .addClass("processed");

        // Inform Masonry about the new grid items.
        $("#block-news-listing")
          .find(".views-infinite-scroll-content-wrapper")
          .masonry("appended", $rows);
      }
    });

    // trigger on window load
    $( window ).on("load", function() {
      $wrapper
      .imagesLoaded(function() {
        $("#block-news-listing")
          .find(".views-infinite-scroll-content-wrapper")
          .masonry({
            horizontalOrder: true,
            itemSelector: ".grid-item",
            percentPosition: true,
            stamp: ".highlight-item",
            gutter: 30
          });
      })
      .find(".grid-item")
      .addClass("processed");
    });
  }
})(jQuery);
